import { useHistoryStore } from '../../../../shared/store/history.store.tsx'
import useAudioStore from '../../../../shared/store/audio.store.tsx'
import useTracksStore, {
  MIX_ID,
} from '../../../../shared/store/tracks.store.tsx'
import { refreshAudioMix } from '../../../../shared/store/use-cases/refresh-audio-mix.ts'

export const recordChange = (): void => {
  useHistoryStore.getState().saveSnapshot()
  useTracksStore.getState().setGeneratedMix(undefined)

  if (useAudioStore.getState().currentAudioId !== MIX_ID) return
  void refreshAudioMix(false)
}
